<div class="btn-grid">
  @for (month of months; track month; let index = $index) {
  <button
    class="btn btn-light month"
    [class.selected]="index === selectedMonth"
    [disabled]="isMonthDisabled(index)"
    (click)="selectMonth(index)"
    data-e2e="month"
  >
    {{ month }}
  </button>
  }
</div>
<div class="btn-grid pt-3" role="group">
  @for (year of years; track year) {
  <button
    class="btn btn-light year"
    [class.selected]="year === selectedYear"
    [disabled]="isYearDisabled(year)"
    (click)="selectYear(year)"
    data-e2e="year"
  >
    {{ year }}
  </button>
  }
</div>
